export default __webpack_public_path__ + "6368a6b8a8797874f8bc5978176c0212.png";